export class AppRoute {
  static AUTHENTICATION = 'auth';
  static DASHBOARD = 'dashboard';
  static SUBSCRIPTION = 'subscription';
}
